// CustomDragLayer.tsx
import React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';

const layerStyles: React.CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 9999,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

const getItemStyles = (currentOffset: XYCoord | null): React.CSSProperties => {
  if (!currentOffset) return { display: 'none' };
  const { x, y } = currentOffset;

  return {
    position: 'fixed',
    top: y + 100,
    left: x + 50,
  };
};

const boxStyles: React.CSSProperties = {
  padding: '8px 12px',
  backgroundColor: 'rgba(2, 131, 160, 0.85)',
  color: '#fff',
  borderRadius: 6,
  fontWeight: 500,
  fontSize: '0.85rem',
  maxWidth: 240,
  transform: 'translateZ(0)', // Hint GPU
  willChange: 'transform',
};

const CustomDragLayer = () => {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || itemType !== 'LINE_ITEM') return null;

  const count = item.selectedRows?.length || 1;

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(currentOffset)}>
        <div style={boxStyles}>
          {count} item{count > 1 ? 's' : ''}
        </div>
      </div>
    </div>
  );
};

export default CustomDragLayer;
